import noop from 'lodash/noop';
import { call, put } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import * as AppConstants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { branch, cond, pipe } from '../../../sagas/Helpers';
import Logger from '../../../tools/Logger';
import * as UseCaseHelpers from '../helpers';

import * as SkipTrackForwardHelpers from './helpers';

const log = Logger.child({ component: 'mediator/useCases/skipTrackForward' });

export function* handleSkipTimeToMusic({ payload }) {
  if (!payload.parentAction) {
    if (payload.skipType === AppConstants.Playback.FragmentRequestReasons.SKIP) {
      yield put(getInDomain('analytics.actions.ttmTrackSkippedTransitionFromMusic', noop)());
    } else {
      yield put(getInDomain('analytics.actions.ttmTrackThumbsDownTransitionFromMusic', noop)());
    }
  }
}

export function* skipTrackForward(action) {
  log.info('skipTrackForward(): starting skip track forward');

  try {
    yield call(
      pipe([
        handleSkipTimeToMusic,
        SkipTrackForwardHelpers.buildSkipTrackForwardDTO,
        branch(
          UseCaseHelpers.isAPS,
          SkipTrackForwardHelpers.handlePlayNextAPSTrack,
          pipe([
            cond([
              [
                SkipTrackForwardHelpers.isTrackUnskippable,
                SkipTrackForwardHelpers.handleUnskippableTrack,
              ],
              [
                SkipTrackForwardHelpers.isTrackFreeSkip,
                SkipTrackForwardHelpers.handleTrackFreeSkip,
              ],
              [() => true, SkipTrackForwardHelpers.handleTrackRewardSkip],
            ]),
            SkipTrackForwardHelpers.handleSpecialStation,
            SkipTrackForwardHelpers.handleSpecialTracks,
            SkipTrackForwardHelpers.handleRegisterSkipTrack,
            SkipTrackForwardHelpers.handleAdOpportunity,
            SkipTrackForwardHelpers.handlePlayNextStationTrack,
            SkipTrackForwardHelpers.handleFlexOpportunity,
            SkipTrackForwardHelpers.handleBingeCheck,
            SkipTrackForwardHelpers.logToDRM,
          ]),
        ),
        SkipTrackForwardHelpers.logToStats,
      ]),
      action,
    );
  } catch (error) {
    yield put(AppActions.UseCases.skipTrackForwardCancel());
  }
}
